import { useTranslation } from 'react-i18next';
import './ShareButtons.css';

const SITE_URL = 'https://www.podiatech.uz';

const ShareButtons = ({ path = '', title = '' }) => {
    const { t } = useTranslation();

    const fullUrl = encodeURIComponent(`${SITE_URL}${path}`);
    const encodedTitle = encodeURIComponent(title || t('share.default_title'));

    const channels = [
        {
            key: 'telegram',
            label: 'Telegram',
            href: `https://t.me/share/url?url=${fullUrl}&text=${encodedTitle}`,
            svg: (
                <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.446 1.394c-.14.18-.357.223-.535.223l.19-2.712 4.94-4.465c.215-.19-.047-.295-.335-.105l-6.107 3.843-2.63-.823c-.572-.18-.582-.572.12-.847l10.27-3.96c.477-.172.896.116.587.874z" />
            ),
        },
        {
            key: 'whatsapp',
            label: 'WhatsApp',
            href: `https://api.whatsapp.com/send?text=${encodedTitle}%20${fullUrl}`,
            svg: (
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
            ),
        },
        {
            key: 'facebook',
            label: 'Facebook',
            href: `https://www.facebook.com/sharer/sharer.php?u=${fullUrl}`,
            svg: (
                <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073c0 6.019 4.388 11.009 10.125 11.927v-8.437H7.078v-3.49h3.047V9.41c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953h-1.514c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.49h-2.796V24C19.612 23.082 24 18.092 24 12.073z" />
            ),
        },
        {
            key: 'copy',
            label: t('share.copy_link'),
            onClick: () => {
                navigator.clipboard.writeText(`${SITE_URL}${path}`);
            },
            svg: (
                <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
            ),
        },
    ];

    return (
        <div className="share-buttons">
            <span className="share-buttons-label">{t('share.label')}</span>
            <div className="share-buttons-list">
                {channels.map((ch) => (
                    <a
                        key={ch.key}
                        href={ch.href || '#'}
                        onClick={(e) => {
                            if (ch.onClick) {
                                e.preventDefault();
                                ch.onClick();
                            }
                        }}
                        target={ch.href ? '_blank' : undefined}
                        rel={ch.href ? 'noopener noreferrer' : undefined}
                        className={`share-btn share-btn-${ch.key}`}
                        aria-label={ch.label}
                        title={ch.label}
                    >
                        <svg viewBox="0 0 24 24" fill="currentColor">
                            {ch.svg}
                        </svg>
                    </a>
                ))}
            </div>
        </div>
    );
};

export default ShareButtons;
